var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"center","margin-top":"170px"}},[_c('img',{staticStyle:{"width":"364px"},attrs:{"src":require("../assets/image/common/error404.png"),"alt":""}}),_c('div',{staticClass:"errorContent"},[_vm._v(" 页面将在"),_c('span',{staticStyle:{"color":"#066eb7"}},[_vm._v(_vm._s(_vm.count))]),_vm._v("秒后回到首页 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }